import { ControlsToggleExtraContent, LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/03/06/principle/large-room-5-khz.svg`,
        },
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [];
